import appStore from 'redux/stores/app.store';
import httpService from 'services/HttpService';
import { generateURLRappiServices } from 'shared/utils/urls';

import { SUBSTITUTION_FLOW_API_PATH } from './substitutionFlow.const';

import type { PartnerId } from 'shared/domain';
import type {
  ItemsReplacementReq,
  RemoveItemReq,
  ReplaceMultipleItemsReq,
  ReplaceSingleItemReq,
  SendSubstitutionEventToChatSupportReq,
  SuggestionsWithAIReq,
  UpdateCancelOrderReq,
} from './substitutionFlow.request';
import type {
  ItemsReplacementRawResp,
  SuggestionsWithAIRawResp,
} from './substitutionFlow.response';

export function readPartnerIdFromProfile(): PartnerId {
  return appStore.getPartnerId();
}

export function readItemsReplacement(params: ItemsReplacementReq) {
  const { payload } = params;
  return httpService.put<ItemsReplacementRawResp>(
    generateURLRappiServices({
      url: SUBSTITUTION_FLOW_API_PATH.READ_ITEMS_REPLACEMENT,
    }),
    payload,
  );
}

export function readSuggestionsWithAI(params: SuggestionsWithAIReq) {
  const { payload } = params;
  return httpService.post<SuggestionsWithAIRawResp>(
    generateURLRappiServices({
      url: SUBSTITUTION_FLOW_API_PATH.READ_SUBSTITUTION_SUGGESTIONS,
    }),
    payload,
  );
}

export function substituteSingleItem(params: ReplaceSingleItemReq) {
  const { payload } = params;
  return httpService.post<never>(
    generateURLRappiServices({
      url: SUBSTITUTION_FLOW_API_PATH.CREATE_SUBSTITUTE_SINGLE_ITEM,
    }),
    payload,
  );
}

export function substituteMultipleItems(params: ReplaceMultipleItemsReq) {
  const { payload } = params;
  return httpService.post<never>(
    generateURLRappiServices({
      url: SUBSTITUTION_FLOW_API_PATH.CREATE_SUBSTITUTE_MULTIPLE_ITEMS,
    }),
    payload,
  );
}

export function sendSubstitutionEventToChatSupport(
  params: SendSubstitutionEventToChatSupportReq,
) {
  const { detail } = params;
  const _customEvent = new CustomEvent('substitution', { detail });
  document.dispatchEvent(_customEvent);
}

export function updateCancelOrder(params: UpdateCancelOrderReq) {
  const { orderId, payload } = params;
  return httpService.post<boolean>(
    generateURLRappiServices({
      url: SUBSTITUTION_FLOW_API_PATH.UPDATE_CANCEL_ORDER,
      pathParams: { orderId },
    }),
    payload,
  );
}

export function removeItem(params: RemoveItemReq) {
  const { orderId, payload } = params;
  return httpService.post<boolean>(
    generateURLRappiServices({
      url: SUBSTITUTION_FLOW_API_PATH.REMOVE_ITEM,
      pathParams: { orderId },
    }),
    payload,
  );
}

export const substitutionFlowRepository = {
  readPartnerIdFromProfile,
  readItemsReplacement,
  substituteSingleItem,
  substituteMultipleItems,
  sendSubstitutionEventToChatSupport,
  updateCancelOrder,
  readSuggestionsWithAI,
  removeItem,
};
